import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
	},
	label: {
		display: 'flex',
		width: '100%',
	},
	title: {
		[theme.breakpoints.down('sm')]: {
			fontSize: 14,
		},
	},
	description: {
		[theme.breakpoints.down('sm')]: {
			fontSize: 12,
		},
	},
	price: {
		[theme.breakpoints.down('sm')]: {
			fontSize: 16,
		},
	},
}));

export default useStyles;
